<template>
    <v-checkbox
        class="mt-0"
        v-model="value"
        hide-details="auto"
    >
        <template slot="label">
            <div class="mt-1">
                {{label}}
            </div>
        </template>
    </v-checkbox>
</template>

<script>
export default {
    props: ['valueInput', 'rule', 'label',],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value)
            }
        }
    }
}
</script>